import _get from "lodash.get";
import _isNil from "lodash.isnil";

export default class Response {
  apiResponse = {};
  schema = null;
  error = null;

  constructor(apiResponse: any) {
    this.apiResponse = apiResponse;
  }

  get isValid(): boolean {
    try {
      this.validate();
      return true;
    } catch (err) {
      this.error = err;
      return false;
    }
  }

  validate() {
    if (this.schema) {
      this.schema.validate(this.apiResponse);
    }
  }

  get success(): boolean {
    return _get(this.apiResponse, "response.data.success", false) === true;
  }

  get data(): any {
    return _get(this.apiResponse, "response.data.response", null);
  }

  get hasError(): boolean {
    if (_get(this.apiResponse, "response", null) === null) {
      return true;
    }

    return _isNil(_get(this.apiResponse, "response.data.error", null)) !== true;
  }

  get hasData(): boolean {
    return this.hasNoData === false;
  }

  get hasNoData(): boolean {
    return _get(this.apiResponse, "response.data.error.code", "") === "warn_no_data";
  }
}
